var map = {
	"./": 61,
	"./development": 163,
	"./development.js": 163,
	"./index": 61,
	"./index.js": 61,
	"./production": 164,
	"./production.js": 164
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 505;


//////////////////
// WEBPACK FOOTER
// ./src/lib/config ^\.\/.*$
// module id = 505
// module chunks = 0